"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSocialShareButton = useSocialShareButton;
const react_1 = require("react");
const CopyToClipboard_1 = __importDefault(require("@web/common/CopyToClipboard"));
const ScreenSize_1 = __importDefault(require("@web/common/ScreenSize"));
const PageHelper_1 = __importDefault(require("@react/web/Common/SocialShareButton/PageHelper"));
function useSocialShareButton() {
    const [url, setUrl] = (0, react_1.useState)(null);
    const [title, setTitle] = (0, react_1.useState)(null);
    const handleCopyToClipboard = (event) => {
        var _a;
        event.preventDefault();
        const copyClipboardInput = (_a = document.getElementsByClassName('copy-clipboard-input')[0]) !== null && _a !== void 0 ? _a : null;
        (0, CopyToClipboard_1.default)(copyClipboardInput.value, () => copyClipboardInput.select());
    };
    const init = () => {
        setTitle(PageHelper_1.default.getOfferTitle());
        setUrl(PageHelper_1.default.getOfferUrl());
    };
    const closePopup = () => {
        var _a;
        const openPopupCheckbox = (_a = document.querySelectorAll('#social-share .open-popup-checkbox')[0]) !== null && _a !== void 0 ? _a : null;
        if (openPopupCheckbox) {
            openPopupCheckbox.checked = false;
        }
    };
    const addEventListeners = () => {
        var _a;
        const openPopupCheckboxElement = (_a = document.querySelectorAll('#social-share .open-popup-checkbox')[0]) !== null && _a !== void 0 ? _a : null;
        if (openPopupCheckboxElement) {
            const ESC_KEY = 27;
            openPopupCheckboxElement.addEventListener('change', (event) => {
                const html = document.documentElement;
                const { body } = document;
                if (event.currentTarget.checked && ScreenSize_1.default.isSmallScreen()) {
                    html.classList.add('mobile-no-scroll');
                    body.classList.add('mobile-no-scroll');
                }
                else {
                    html.classList.remove('mobile-no-scroll');
                    body.classList.remove('mobile-no-scroll');
                }
            });
            document.addEventListener('keyup', (event) => {
                if (event.which === ESC_KEY) {
                    closePopup();
                }
            });
            document.addEventListener('click', (event) => {
                const socialShareElement = document.getElementById('social-share');
                if (socialShareElement && event.target) {
                    const isClickedOutsideSharePopup = event.target !== socialShareElement
                        && socialShareElement.contains(event.target) === false;
                    if (isClickedOutsideSharePopup === true && ScreenSize_1.default.isSmallScreen() === false) {
                        closePopup();
                    }
                }
            });
        }
    };
    (0, react_1.useEffect)(() => {
        init();
    }, []);
    (0, react_1.useEffect)(() => {
        addEventListeners();
    }, [url, title]);
    return {
        handleCopyToClipboard,
        url,
        title,
    };
}
